(function () {
  'use strict';

  var nativeCollection = document.querySelector('[data-gettmi-native-collection]');
  if (!nativeCollection) return;

  function safeBack() {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.assign((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
  }

  var backButton = nativeCollection.querySelector('[data-gettmi-collection-back]');
  if (backButton) backButton.addEventListener('click', safeBack);

  var filterButton = document.querySelector('[data-gettmi-open-collection-filters]');
  if (filterButton) {
    filterButton.addEventListener('click', function () {
      var drawerSummary = document.querySelector('.mobile-facets__open-wrapper');
      if (drawerSummary) drawerSummary.click();
    });
  }
  var filterCloseButton = document.querySelector('[data-gettmi-close-collection-filters]');
  if (filterCloseButton) {
    filterCloseButton.addEventListener('click', function () {
      var drawerSummary = document.querySelector('.mobile-facets__open-wrapper');
      if (drawerSummary) drawerSummary.click();
    });
  }

  var sortButton = document.querySelector('[data-gettmi-collection-sort-open]');
  var sortMenu = document.querySelector('[data-gettmi-collection-sort-menu]');

  function closeSort() {
    if (!sortButton || !sortMenu) return;
    sortMenu.hidden = true;
    sortButton.setAttribute('aria-expanded', 'false');
  }

  if (sortButton && sortMenu) {
    sortButton.addEventListener('click', function () {
      var opens = sortMenu.hidden;
      sortMenu.hidden = !opens;
      sortButton.setAttribute('aria-expanded', opens ? 'true' : 'false');
    });

    sortMenu.addEventListener('click', function (event) {
      var option = event.target.closest('[data-gettmi-sort-value]');
      if (!option) return;
      var url = new URL(window.location.href);
      var value = option.dataset.gettmiSortValue || '';
      if (value) {
        url.searchParams.set('sort_by', value);
      } else {
        url.searchParams.delete('sort_by');
      }
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.gettmi-collection-sort')) closeSort();
    });
  }

  var rail = document.querySelector('[data-gettmi-catalogue-discs]');
  if (!rail) return;

  var parentHandle = String(rail.dataset.parentHandle || '').trim().toLowerCase();
  var allowedParents = ['all-dresses', 'all-clothing', 'all-accessories', 'view-all-shoes'];
  if (allowedParents.indexOf(parentHandle) === -1) {
    rail.hidden = true;
    return;
  }

  var config = document.querySelector('[data-gettmi-supabase]');
  var row = rail.querySelector('[data-gettmi-catalogue-disc-row]');
  var skeleton = rail.querySelector('.gettmi-catalogue-discs__skeleton');
  var collectionBase = String(rail.dataset.collectionBase || '/collections').replace(/\/+$/, '');

  function hideRail() {
    rail.hidden = true;
    document.documentElement.classList.remove('gettmi-collection-has-discs');
  }

  function isSafeHandle(value) {
    return /^[a-z0-9][a-z0-9-]*$/.test(value);
  }

  function imageUrl(item, supabaseUrl) {
    var bucket = String(item.image_bucket || '').trim();
    var path = String(item.image_path || '').trim();
    var fallback = String(item.fallback_image_url || '').trim();
    if (!isSafeHandle(bucket) || !path || path.charAt(0) === '/' || path.indexOf('..') !== -1) return fallback;
    var version = encodeURIComponent(String(item.image_asset_version || '').trim());
    return supabaseUrl + '/storage/v1/render/image/public/' + bucket + '/' + path
      + '?width=144&height=144&quality=76&resize=cover'
      + (version ? '&v=' + version : '');
  }

  function validFeed(feed) {
    if (!feed || feed.schema_version !== 1 || feed.parent_handle !== parentHandle) return false;
    if (feed.configured !== true || feed.enabled !== true || feed.ready !== true) return false;
    if (Number(feed.expected_count) !== 5 || !Array.isArray(feed.items) || feed.items.length !== 5) return false;
    var handles = Object.create(null);
    return feed.items.every(function (item, index) {
      var handle = String(item && item.collection_handle || '').trim();
      var title = String(item && item.display_title || '').trim();
      var fallback = String(item && item.fallback_image_url || '').trim();
      var position = Number(item && item.position);
      var count = Number(item && item.product_count);
      if (!isSafeHandle(handle) || handle === parentHandle || handles[handle]) return false;
      handles[handle] = true;
      return position === index + 1
        && title.length > 0
        && title.length <= 120
        && Number.isInteger(count)
        && count > 0
        && fallback.indexOf('https://') === 0;
    });
  }

  function renderFeed(feed, supabaseUrl) {
    row.textContent = '';
    feed.items.forEach(function (item) {
      var handle = String(item.collection_handle).trim();
      var title = String(item.display_title).trim();
      var link = document.createElement('a');
      var ring = document.createElement('span');
      var image = document.createElement('img');
      var label = document.createElement('span');

      link.className = 'gettmi-catalogue-disc';
      link.href = collectionBase + '/' + handle;
      link.setAttribute('aria-label', title + ' collection');
      link.title = String(item.product_count) + ' products';
      ring.className = 'gettmi-catalogue-disc__ring';
      image.src = imageUrl(item, supabaseUrl);
      image.alt = '';
      image.width = 54;
      image.height = 54;
      image.loading = 'eager';
      image.addEventListener('error', function () {
        var fallback = String(item.fallback_image_url || '');
        if (image.src !== fallback) image.src = fallback;
      }, { once: true });
      label.className = 'gettmi-catalogue-disc__label';
      label.textContent = title.toUpperCase();
      ring.appendChild(image);
      link.appendChild(ring);
      link.appendChild(label);
      row.appendChild(link);
    });
    if (skeleton) skeleton.hidden = true;
    row.hidden = false;
    rail.hidden = false;
    document.documentElement.classList.add('gettmi-collection-has-discs');
  }

  if (!config || !row) {
    hideRail();
    return;
  }

  var supabaseUrl = String(config.dataset.supabaseUrl || '').replace(/\/+$/, '');
  var supabaseKey = String(config.dataset.supabaseKey || '');
  if (!supabaseUrl || !supabaseKey) {
    hideRail();
    return;
  }

  var controller = new AbortController();
  var timeout = window.setTimeout(function () {
    controller.abort();
  }, 7000);

  fetch(supabaseUrl + '/rest/v1/rpc/get_catalogue_disc_feed', {
    method: 'POST',
    headers: {
      apikey: supabaseKey,
      Authorization: 'Bearer ' + supabaseKey,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ p_parent_handle: parentHandle }),
    signal: controller.signal
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Catalogue discs unavailable');
      return response.json();
    })
    .then(function (feed) {
      if (!validFeed(feed)) throw new Error('Catalogue disc feed invalid');
      renderFeed(feed, supabaseUrl);
    })
    .catch(hideRail)
    .finally(function () {
      window.clearTimeout(timeout);
    });
})();
